var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEventplusicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 15.5C11.6423 15.5 15 12.1423 15 8C15 3.85775 11.6423 0.5 7.5 0.5C3.35775 0.5 0 3.85775 0 8C0 12.1423 3.35775 15.5 7.5 15.5ZM6.75 5C6.75 4.80109 6.82902 4.61032 6.96967 4.46967C7.11032 4.32902 7.30109 4.25 7.5 4.25C7.69891 4.25 7.88968 4.32902 8.03033 4.46967C8.17098 4.61032 8.25 4.80109 8.25 5V7.25H10.5C10.6989 7.25 10.8897 7.32902 11.0303 7.46967C11.171 7.61032 11.25 7.80109 11.25 8C11.25 8.19891 11.171 8.38968 11.0303 8.53033C10.8897 8.67098 10.6989 8.75 10.5 8.75H8.25V11C8.25 11.1989 8.17098 11.3897 8.03033 11.5303C7.88968 11.671 7.69891 11.75 7.5 11.75C7.30109 11.75 7.11032 11.671 6.96967 11.5303C6.82902 11.3897 6.75 11.1989 6.75 11V8.75H4.5C4.30109 8.75 4.11032 8.67098 3.96967 8.53033C3.82902 8.38968 3.75 8.19891 3.75 8C3.75 7.80109 3.82902 7.61032 3.96967 7.46967C4.11032 7.32902 4.30109 7.25 4.5 7.25H6.75V5Z",
    fill: "#D10A11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventplusicon);
export default __webpack_public_path__ + "static/media/eventplusicon.d30ad14c02f397db337c683a4c50f524.svg";
export { ForwardRef as ReactComponent };